import { complete as tokenComplete } from './token';
import getUser from './user';

export default (userManager) => {
  userManager.signinRedirectCallback().then((user) => {
    if (user) {
      const currentRedirectURI = sessionStorage.getItem('currentRedirectURI');
      
      window.location.href = currentRedirectURI;
      tokenComplete(user);
      return;
    }
    getUser(userManager);
  }).catch( (err) => {
    getUser(userManager)
  });
}
